export enum DateType {
  LastUpdateTime = 2,
  TaggedDate = 3,
  ValidatedDate = 6,
  ReviewDate = 10,
  AuditedDate = 11,
  GisReviewDate = 13,
}